import {
    AntdTableResponseOfListOfEventLogDto,
    ArrivingFromLookupDto,
    CqmCapabilityDto,
    CqmMeasureConfigurationDto,
    CqmMeasureValueSetBindingDto,
    EventLogSearchDto,
    FacilityDto,
    HospiceCompanyDto,
    HospitalSystemDto,
    PatientTypeDto,
    RegionDto,
    ReturnToHospitalConfigurationDto,
    UserDto,
} from '@medone/medonehp-api-client';

import { DsiInterventionDto, DsiRuleDto, DsiRuleVocabularyDto } from './components/dsi-interventions/types';

export interface AdminState {
    errorMessage: string | null;
    regions: RegionDto[];
    currentRegion: RegionDto;
    facilities: FacilityDto[];
    currentFacility: FacilityDto;
    patientTypes: PatientTypeDto[];
    currentPatientType: PatientTypeDto;
    arrivingFroms: ArrivingFromLookupDto[];
    currentArrivingFrom: ArrivingFromLookupDto;
    eventLogs: AntdTableResponseOfListOfEventLogDto;
    eventLogFilter: EventLogSearchDto;
    hospitalSystems: HospitalSystemDto[];
    currentHospitalSystem: HospitalSystemDto;
    users: UserDto[];
    physicianUsers: UserDto[];
    appUsers: UserDto[];
    woundProviders: UserDto[];
    returnToHospitalConfigurations: ReturnToHospitalConfigurationDto[];
    hospiceCompanies: HospiceCompanyDto[];
    currentHospiceCompany: HospiceCompanyDto;
    cqmCapability: CqmCapabilityDto | null;
    cqmMeasureConfiguration: CqmMeasureConfigurationDto | null;
    cqmValueSetBindings: Record<string, CqmMeasureValueSetBindingDto>;
    dsiInterventions: DsiInterventionDto[] | null;
    dsiInterventionsAccessDenied: boolean;
    /** The API's explanation of the last failed save (400 validation, 409 conflict); shown inside the drawer. */
    dsiInterventionsSaveError: string | null;
    /** Trigger rules per intervention key, loaded when the drawer's Rules tab opens. */
    dsiRules: Record<string, DsiRuleDto[]>;
    dsiRuleVocabulary: DsiRuleVocabularyDto | null;
    /** The API's explanation of the last failed rule write (400 validation, 409 conflict), shown in the Rules tab. */
    dsiRulesError: string | null;
}

export const initialState: AdminState = {
    errorMessage: null,
    regions: null,
    currentRegion: null,
    facilities: null,
    currentFacility: null,
    patientTypes: null,
    currentPatientType: null,
    arrivingFroms: null,
    currentArrivingFrom: null,
    eventLogs: null,
    eventLogFilter: null,
    hospitalSystems: null,
    currentHospitalSystem: null,
    users: [],
    physicianUsers: [],
    appUsers: [],
    woundProviders: [],
    returnToHospitalConfigurations: [],
    hospiceCompanies: [],
    currentHospiceCompany: null,
    cqmCapability: null,
    cqmMeasureConfiguration: null,
    cqmValueSetBindings: {},
    dsiInterventions: null,
    dsiInterventionsAccessDenied: false,
    dsiInterventionsSaveError: null,
    dsiRules: {},
    dsiRuleVocabulary: null,
    dsiRulesError: null,
};
